import React from 'react';
import { useTranslation } from 'next-i18next';
import AuthenticationGuard from '@components/atoms/authentication/authentication-guard/authentication-guard';
import Button from '@components/atoms/button/button';

type CreateAlertButtonProps = {
  buttonClass: string;
  icon: React.ReactElement;
  onClick: () => void;
  isAlertCreating: boolean;
  label: string;
};

const CreateAlertButton: React.FC<CreateAlertButtonProps> = (props) => {
  const { buttonClass, onClick, icon, isAlertCreating, label } = props;

  const { t } = useTranslation();

  return (
    <AuthenticationGuard onAuth={onClick}>
      <Button
        disabled={isAlertCreating}
        disableDefaultStyling
        className={buttonClass}
        onClick={onClick}
        data-vc-dd-action-name="manageAlerts_createAlert"
      >
        {icon}
        {t(label)}
      </Button>
    </AuthenticationGuard>
  );
};

export default CreateAlertButton;
